export default __webpack_public_path__ + "static/media/emptyBox.92859156.svg";